<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>EDD Report</strong>
          </div>

          <div>
            <b-row>
              <b-col cols="4">
                <b-form-group label="From Date : " :label-cols="3">
                  <v-date-picker mode="single" input-class="dateInput"
                    :available-dates="{ start: null, end: new Date() }" v-model="fromDate">
                  </v-date-picker>
                </b-form-group>
              </b-col>

              <b-col cols="3"  class="pr-0">
                <b-form-group label="To Date : " :label-cols="3">
                  <v-date-picker mode="single" input-class="dateInput"
                    :available-dates="{ start: null, end: new Date() }" v-model="toDate">
                  </v-date-picker>
                </b-form-group>
              </b-col>

              <b-col cols="5">
                <b-form-group label="Select Hub : " :label-cols="3">
                  <!-- <b-form-select v-model="selectedhub">
                    <option :value="select">-- Select Hub --</option>
                    <option :value="hub" v-for="hub in hubItems" :key="hub.hubid">
                      {{ hub.name }} - {{ hub.type }}
                    </option>
                  </b-form-select> -->

                  <ejs-multiselect id='multiselect' key="hub_multiselect" placeholder="Select Hub" v-model="selectedHubs" :dataSource='hubOptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"  :fields='hubFields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
            ></ejs-multiselect> 
                </b-form-group>
              </b-col>

              <b-col cols="5">
                <b-form-group label="Select Gap Days : " :label-cols="4">
                  <b-form-select v-model="selectedGapDay">
                    <option :value="null">-- Select Gap Days --</option>
                    <option v-for="gapDay in gapDaysOptions" :key="gapDay.gap_days" :value="gapDay.gap_days">
                      {{ gapDay.gap_days }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="7" style="text-align:right;">
                <b-form-group>
                  <button class="btn btn-primary" @click="getEDDReportListing(1,'no')"> Search </button>
                  <button class="btn btn-danger ml-2" @click="clear()"> Clear </button>
                  <button class="btn btn-primary ml-4" @click="downloadEDDReport" :disabled="totalRows==0"> Download
                  </button>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="my-2">
              <b-col sm="12" class="text-right">
                <b-col sm="12">
                  <p> <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
                </b-col>
              </b-col>
            </b-row>

            <b-col sm="12">
              <b-table show-empty responsive :items="items" :busy="isBusy" :current-page="currentPage" :fields="fields"
                :per-page="perPage" :bordered="bordered">

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

                <template slot="mpscount" slot-scope="row">
                  <button title="View Details" @click="openDetailsModal(row.item)"
                    style="background-color: white !important;" class="btn btn-link">
                    <span style="color:#1b8eb7">{{ row.item.mpscount }}</span>
                  </button>
                </template>

              </b-table>
            </b-col>

            <b-col sm="12" class="my-1">
              <paginate v-model="pageNum" :page-count="noofpages" :page-range="10" :margin-pages="2"
                :click-handler="clickCallback" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"
                :page-class="'page-item'" :current-page="currentPage">
              </paginate>
            </b-col>

            <b-modal size="xl" title="Count Details" v-model="detailsModal" @ok="detailsModal = false"  hide-footer>
              <b-row>
                <b-col sm="12" class="text-right">
                  <p> <b>Total Records :<span style="color:red;">{{ totalDetailsRows }}</span></b> </p>
                </b-col>

                <div style="float: left;">
                  <span class="badge ml-2" 
                  style="background-color:rgb(192, 57, 43); color: white;font-size: 13px; padding: 3px;">DB</span> Damage Box&nbsp;&nbsp;
                  <span class="badge ml-2" 
                    style="background-color:rgb(23, 130, 109); color: white;font-size: 11px; padding: 3px;">SB</span> Shortage Box&nbsp;&nbsp;
                </div>

                <b-col sm="12">
                  <b-table show-empty responsive :items="detailsItems" :busy="isDetailsBusy" :current-page="currentPage1" :per-page="perPage1"
                    :fields="detailsFields" :bordered="bordered">

                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                    <template slot="shippingid" slot-scope="row">
											<span>{{row.item.shippingid}}</span>
											<br>
											<span v-if="row.item.is_defective=='YES'" class="badge "
												style="background-color:#c0392b;color:white;font-size: 9px;padding: 3px; cursor: pointer;"
												v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
											&nbsp;
											<span v-if="row.item.is_shortage=='Yes'" class="badge "
												style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px; cursor: pointer;">SB</span>
										</template>

										<template slot="mpsvalue" slot-scope="row">
											<span>&#8377;{{row.item.mpsvalue}}</span>
										</template>

										<template slot="physicalweight" slot-scope="row">
											<span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
										</template>

										<template slot="LBH" slot-scope="row">
											<span> {{row.item.breadth}}*{{row.item.length}}*{{row.item.height}}</span>
										</template>

										<!-- <template slot="lastmodifieddate" slot-scope="row">
											<div>
												{{ row.item.lastmodifieddate | ConvertTime12hour() }}
											</div>
										</template> -->

                  </b-table>
                </b-col>

								<b-col sm="12" class="my-1" v-if="totalDetailsRows>10">
									<b-pagination v-model="currentPage1" :total-rows="totalDetailsRows" :per-page="perPage1"
										class="my-0"></b-pagination>
                    
								</b-col>
              </b-row>
            </b-modal>

            <b-modal size="md" id="defective_image_modal" title="Defective Image" hide-footer>
              <div v-if="selected_user_details.defective_imageurl==null" class="text-center">
                No Record Found
              </div>
              <div v-else class="text-center">
                <img :src="selected_user_details.defective_imageurl" width="100%" height="100%" />
              </div>
            </b-modal>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
export default {
  data: function () {
    return {
      name: "EDD_report",
      isBusy: false,

      //Filter Fields
      fromDate: null,
      toDate: null,
      hubItems:{},
      hubOptions:[],
      selectedHubs:[],
      hubFields: { text: 'name', value: 'id' },
      //  selectedhub:'',
      //  select :'',
      showSelectAll : true,
      allowCustomValue : true,
      gapDaysOptions: [],
      selectedGapDay: null,
      selectDay: '',

      //Table Fields
      items: [],
      fields: [
        { key: 'parentawb', label: 'Parent AWB' },
        { key: 'warehousename', label: 'Origin WH'},
        { key: 'last_dispatched_from', label: 'Last Dispatched From' },
        { key: 'invoiceno', label: 'Load ID' },
        { key: 'accounttype', label: 'Account Type' },
        { key: 'mpscount', label: 'No of boxes' },
        { key: 'zoneinscandate', label: 'Zone InScan Date' },
        { key: 'dispatchoutscandate', label: 'Dispatch OutScan Date' },
        { key: 'calulatededd', label: 'EDD' },
        { key: 'gap_days', label: 'Gap Days' },
        { key: 'shipmentstatus', label: 'Load Status' },
        { key: 'origin_city', label: 'Origin City'},
        { key: 'destination_city', label: 'Destination City'},
        { key: 'dispatched_vehicle', label: 'Dispatch Vehicle' },
        { key: 'assigned_vehicle', label: 'Assigned Vehicle'},
      ],
      bordered: true,
      totalRows: 0,
      currentPage: 1,
      pageNum:1,
      perPage: 20,
      noofpages: 0,
      downloadreport: '',

      //Details Modal Fields
      detailsModal: false,
      isDetailsBusy: false,
      detailsItems:[],
      detailsFields:[
        { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
        { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
        { key: 'LBH', label: 'LBH', sortable: true, sortDirection: 'desc' },
        { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
        { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
        { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
        { key: 'hub_title', label: 'Hub Name', sortable: true, sortDirection: 'desc' },
        { key: 'zone_title', label: 'Zone Name', sortable: true, sortDirection: 'desc' },
        { key: 'lastmodifiedby', label: 'Last Modified By', sortable: true, sortDirection: 'desc' },
        { key: 'lastmodifieddate', label: 'Last Modified On', sortable: true, sortDirection: 'desc' }
      ],
      totalDetailsRows: 0,
      currentPage1: 1,
      pageNum1: 1,
      perPage1: 10,
      noofpages1: 0,

      selected_user_details: '',
    }
  },
  created: function(){
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.hubListing();
    this.getEDDReportListing(1,'yes');
    this.gapDaysListing();
  },
  methods:{
    hubListing() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj = {

      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllDistinctStockistAndHubs`, obj)
      .then(result => {
        if (result.body.returnmsg === "Successful") {
          this.hubOptions = [];
          // this.hubItems = result.body.returnvalue;
          result.body.returnvalue.forEach(item => {
            let tempObj = { id: `${item.type}-${item.name}`, name: `${item.name} - ${item.type}` }
            this.hubOptions.push(tempObj)
            this.hubItems[`${item.type}-${item.name}`] = item;
          })
        } 
        else{
          this.hubItems ={};
          this.hubOptions = [];
        }
      })
      .catch(ex => {
        console.log("error", ex);
      });
    },

    gapDaysListing(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const obj = {

      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllDistinctGapDaysForDropDown`, obj)
      .then(result => {
        if (result.body.returnmsg === "Successful") {
          this.gapDaysOptions = result.body.returnvalue; 
          // this.gapDaysOptions = Array.from({ length: maxday }, (v, k) => k + 1);
        } 
        else{
          this.gapDaysOptions = [];
          this.$fire({
            text: result.body.returnvalue,
            type: "warning",
            timer: 30000
          });
        }
      })
      .catch(ex => {
        console.log("error", ex);
      });
    },

    getEDDReportListing(page,getAll){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.isBusy=true;
      console.log("selected hubs-->",this.selectedHubs);

      if (page == 1) {
        this.items = [];
        this.pageNum = 1;
        this.totalRows = 0;
        this.noofpages = 0;
      }

      // if(this.selectedGapDay || this.selectedHubs.length>0){
      //   this.$fire({
      //     text: "Please Select date filter",
      //     type: "warning",
      //     timer: 30000
      //   });
      //   this.isBusy = false;
      //   return
      // }

      if((this.fromDate && !this.toDate) || (!this.fromDate && this.toDate)){
        this.$fire({
          text: "Please Select Both Dates if you want to apply date filter",
          type: "warning",
          timer: 30000
        });
        this.isBusy = false;
        return
      }

      if (this.fromDate > this.toDate) {
        this.$fire({
          text: "From date must be smaller than To date",
          type: "warning",
          timer: 30000
        });
        this.isBusy = false;
        return
      }

      let tempArr = [];
      this.selectedHubs.forEach(hub=>{
        tempArr.push(this.hubItems[hub])
      })

      console.log("tempArr-->",tempArr)

      const obj = {
        startdate : this.fromDate ? this.formatDate(this.fromDate) : null,
        enddate : this.toDate ? this.formatDate(this.toDate) : null,
        allstockandhubs : tempArr,
        gapdays : this.selectedGapDay ? this.selectedGapDay : null,
        pageno : page ? page : 1,
        getAll : (this.fromDate || this.toDate || tempArr.length != 0 || this.selectedGapDay) ? 'no' : 'yes',
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getEddGapDaysListingCMSApi`, obj)
      .then(result => {
        this.isBusy=false;
        if (result.body.returnmsg === "Successful") {
          this.items = result.body.returnvalue;
          this.totalRows = result.body.totalcount;  
          this.noofpages=parseInt(this.totalRows)/this.perPage;
          this.noofpages=Math.ceil( this.noofpages);  
        } 
        else{
          this.items = [];
          this.totalRows = 0;
          this.noofpages = 0;
          this.$fire({
            text: result.body.returnvalue,
            type: "warning",
            timer: 30000
          });
        }
      })
      .catch(ex => {
        this.isBusy=false;
        console.log("error", ex);
      });
    },

    downloadEDDReport() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      let tempArr = [];
      this.selectedHubs.forEach(hub=>{
        tempArr.push(this.hubItems[hub])
      })

      const Obj = {
        startdate : this.fromDate ? this.formatDate(this.fromDate) : null,
        enddate : this.toDate ? this.formatDate(this.toDate) : null,
        allstockandhubs : tempArr,
        gapdays : this.selectedGapDay ? this.selectedGapDay : null,
        emailid : userInfo.sysemailid,
        getAll : (this.fromDate || this.toDate || tempArr.length != 0 || this.selectedGapDay) ? 'no' : 'yes',
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/eddreportDownLoadCSV`, Obj)
        .then(result => {
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000
            });
          }
          else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000
            });
          }
        })
        .catch(ex => {
          console.log('error', ex)
        })
    },

    downloadReport(data) {
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + data;
      anchor.download = 'EDDReport.csv';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    },

    openDetailsModal(value){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.currentPage1 = 1;
      this.detailsItems = [];
      this.totalDetailsRows = 0;
      this.detailsModal = !this.detailsModal;
      this.isDetailsBusy = true;

      const obj ={
        parentawb: value.parentawb,
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getMPSListFromLoad`, obj)
      .then(result => {
        this.isDetailsBusy=false;
        if (result.body.returnmsg === "successful") {
          this.detailsItems = result.body.returnvalue;
          this.totalDetailsRows = result.body.returnvalue.length  
        } 
        else{
          this.detailsItems = [];
          this.totalDetailsRows = 0;
          this.$fire({
            text: result.body.returnvalue,
            type: "warning",
            timer: 30000
          });
        }
      })
      .catch(ex => {
        this.isDetailsBusy=false;
        console.log("error", ex);
      });
    },

    Viewimagedetails: function (data) {
      this.selected_user_details = data;
    },

    clickCallback(pageNum) {
      this.getEDDReportListing(pageNum,'yes');
    },

    clear(){
      this.fromDate = null;
      this.toDate = null;
      this.selectedHubs = [];
      this.selectedGapDay = null;
      this.getEDDReportListing(1,'yes');
    },

    formatDate: function (date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
}

</script>

<style>

</style>